import { TransactionStatus } from '@ankor-io/common/types/transaction/transaction'
import { AWXCardActivityEventStatus } from '@ankor-io/common/types/transaction/transaction'

export const getCardTransactionStatusColour = (status: AWXCardActivityEventStatus) => {
  switch (status) {
    case AWXCardActivityEventStatus.SUCCEEDED:
      return 'green'
    case AWXCardActivityEventStatus.FAILED:
      return 'red'
    default:
      return 'gray'
  }
}

export const getStatusColour = (status: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.SUBMITTED:
      return 'primary'
    case TransactionStatus.INCOMPLETE:
      return 'yellow'
    case TransactionStatus.APPROVED:
      return 'green'
    case TransactionStatus.REJECTED:
      return 'red'
    default:
      return 'gray'
  }
}

export const getStatusText = (status: TransactionStatus): string => {
  switch (status) {
    case TransactionStatus.INCOMPLETE:
      return 'Incomplete'
    case TransactionStatus.SUBMITTED:
      return 'Ready for review'
    case TransactionStatus.APPROVED:
      return 'Approved'
    case TransactionStatus.REJECTED:
      return 'Denied'
    default:
      return status
  }
}
